export default "__VITE_ASSET__DOQvzbPu__"